import { usePage } from '@inertiajs/react';

export function useTrans() {
    const { translations = {} } = usePage().props;

    return function t(key, replacements = {}) {
        let value = translations[key] ?? key;

        Object.entries(replacements).forEach(([k, v]) => {
            value = value.replace(`:${k}`, v);
        });

        return value;
    };
}
